import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Col } from "react-bootstrap"

import { ACTIVE, YES } from "const"
import {
    StoreType,
    ProjectActiveModules,
    moduleIds,
} from "client/store"
import {
    FormGroup,
    Label,
    CheckButton,
    CheckboxWrapper,
} from "client/components"


interface ProjectModule {
    id: number | string
    name: string
}
interface ModulesProps {
    activeModules: ProjectActiveModules
    onChange: (value: ProjectActiveModules) => void
    title: string
}

const ProjectModules = ({
    activeModules,
    onChange,
    title,
}: ModulesProps) => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)

    const [projectModules, setProjectModules] = useState<ProjectModule[]>([])

    useEffect(() => {
        const {
            ccModuleAccess,
            lifecycleModuleAccess,
            silModuleAccess,
            qidModuleAccess,
            rrsRiskSpaceModuleAccess,
            studyModuleAccess,
        } = packageSettings
        const {
            cc,
            lifecycle,
            sil,
            qid,
            riskSpace,
            study,
        } = moduleIds

        const modules = []

        if (ccModuleAccess === YES && moduleList[cc].status === ACTIVE) {
            modules.push({
                id: cc,
                name: moduleList[cc].name,
            })
        }
        if (lifecycleModuleAccess === YES && moduleList[lifecycle].status === ACTIVE) {
            modules.push({
                id: lifecycle,
                name: moduleList[lifecycle].name,
            })
        }
        if (silModuleAccess === YES && moduleList[sil].status === ACTIVE) {
            modules.push({
                id: sil,
                name: moduleList[sil].name,
            })
        }
        if (qidModuleAccess === YES && moduleList[qid].status === ACTIVE) {
            modules.push({
                id: qid,
                name: moduleList[qid].name,
            })
        }
        if (rrsRiskSpaceModuleAccess === YES && moduleList[riskSpace].status === ACTIVE) {
            modules.push({
                id: riskSpace,
                name: moduleList[riskSpace].name,
            })
        }
        if (studyModuleAccess === YES && moduleList[study].status === ACTIVE) {
            modules.push({
                id: study,
                name: moduleList[study].name,
            })
        }

        setProjectModules(modules)
    }, [])

    const columnNumber = 3
    const columnLength = Math.ceil(projectModules.length / columnNumber)
    const columns: { [k: number]: ProjectModule[] } = {}

    for (let i = 0; i < columnNumber; i++) {
        const column = []
        const start = i * columnLength
        const end = start + columnLength
        for (let k = start; k < end; k++) {
            column.push(projectModules[k] || null)
        }
        columns[i] = column
    }

    return (
        <FormGroup>
            <Label>{title}</Label>
            <CheckboxWrapper>
                {
                    Object.keys(columns).map((index) => {
                        const modules = columns[Number(index)]
                        const content = modules.map((module) => module && (
                            <CheckButton
                                key={module.id}
                                checked={activeModules[module.id]}
                                onChange={() => {
                                    const newModules = { ...activeModules }
                                    const moduleStatus = newModules[module.id]
                                    newModules[module.id] = !moduleStatus
                                    onChange(newModules)
                                }}
                                title={module.name}
                            />
                        ))
                        return <Col key={index} xs={12} md={4}>{content}</Col>
                    })
                }
            </CheckboxWrapper>
        </FormGroup>
    )
}
export default ProjectModules
